import React, { useCallback, useState } from 'react';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import AreaTitle from '../../../components/areaTitle/AreaTitle';
import Toast from '../../../components/support/Toast';
import CatalogTab from './components/catalog/CatalogTab';
import EditionsTab from './components/editions/EditionsTab';

/**
 * AdminChangelog - Novidades da Gabriela (Admin Geral)
 *
 * Duas abas (docs/features/changelog/CATALOGO-E-ENVIOS.md):
 * - Envios: o próximo e-mail de novidades (rascunho sempre presente) e os envios anteriores,
 *   com editor, prévia, agendamento, envio imediato e métricas.
 * - Catálogo: todas as novidades criadas pelo /gabriela-app-changelog ou aqui, com publicação em lote.
 */
function AdminChangelog() {
  const [activeTab, setActiveTab] = useState('editions');
  const [toast, setToast] = useState({ open: false, message: '', severity: 'success' });

  const notify = useCallback((message, severity = 'success') => {
    setToast({ open: true, message, severity });
  }, []);

  return (
    <Box sx={{ backgroundColor: '#F8F9FC', minHeight: '100vh', p: { xs: 2, md: 3 } }}>
      <Box sx={{ mb: 3 }}>
        <AreaTitle
          Title="Admin Geral · Novidades"
          Icon={<AutoAwesomeOutlinedIcon />}
          Description="Catálogo de novidades e envios do e-mail de novidades."
        />
      </Box>

      <Tabs value={activeTab} onChange={(_, value) => setActiveTab(value)} sx={{ mb: 3, borderBottom: '1px solid #E8ECF0' }}>
        <Tab value="editions" label="Envios" />
        <Tab value="catalog" label="Catálogo" />
      </Tabs>

      {activeTab === 'editions' ? <EditionsTab notify={notify} /> : <CatalogTab notify={notify} />}

      <Toast
        open={toast.open}
        onClose={() => setToast((prev) => ({ ...prev, open: false }))}
        message={toast.message}
        severity={toast.severity}
        autoHideDuration={6000}
      />
    </Box>
  );
}

export default AdminChangelog;
